import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
}

/**
 * Shared shell for /admin/* pages. Renders a top tab bar that mirrors the
 * `AdminRoute`-gated routes mounted in `App.tsx`. Adding a new admin panel
 * is two lines: a route in App.tsx and a `<NavLink>` here.
 */
export function AdminLayout({ children }: Props): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="admin-shell">
      <nav className="admin-tabs" aria-label={t('admin.layout.sectionsLabel')}>
        <NavLink
          to="/admin/access-codes"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.layout.accessCodes')}
        </NavLink>
        <NavLink
          to="/admin/recruiters"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.recruiters.tab')}
        </NavLink>
        <NavLink
          to="/admin/constants"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.layout.constants')}
        </NavLink>
        <NavLink
          to="/admin/health"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.layout.serviceHealth')}
        </NavLink>
        <NavLink
          to="/admin/sports-health"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.layout.sportsHealth')}
        </NavLink>
        <NavLink
          to="/admin/sports-vod-resolve-cache"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.layout.vodResolveCache')}
        </NavLink>
        <NavLink
          to="/admin/spending"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.layout.spending')}
        </NavLink>
        <NavLink
          to="/admin/feature-flags"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.layout.featureFlags')}
        </NavLink>
        <NavLink
          to="/admin/logs"
          className={({ isActive }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`}
        >
          {t('admin.layout.logs')}
        </NavLink>
      </nav>
      {children}
    </div>
  );
}
